import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

export const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  // WhatsApp number (remove + and - for the link)
  const whatsappNumber = '15877090167';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=Hello%2C%20I%27m%20interested%20in%20your%20surgical%20instruments`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        transition: 'all 0.3s ease'
      }}
    >
      {/* WhatsApp Button */}
      <div className="relative">
        <div 
          className="flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
        >
          <MessageCircle className="w-7 h-7" fill="white" />
        </div>
        
        {/* Tooltip */}
        {isHovered && (
          <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg shadow-lg whitespace-nowrap">
            <span className="text-sm font-medium">Chat with us on WhatsApp</span>
            <div className="absolute right-0 top-1/2 transform translate-x-2 -translate-y-1/2">
              <div className="w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
          </div>
        )}
        
        {/* Pulse animation */}
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></div>
      </div>
    </a>
  );
};
